<template>
	<header
		class="sticky top-0 flex items-center gap-4 h-[var(--header-height)] z-[50] border-b border-black px-10 bg-white"
		data-boxy-header
	>
		<NuxtLink
			to="/"
			class="text-2xl text-gray-700 font-bold uppercase w-full max-w-[340px] max-md:hidden"
		>
			<img src="/logos/boxy-logo-light.png" alt="Boxy" width="150" height="44" />
		</NuxtLink>
		<Icon
			name="solar:hamburger-menu-linear"
			@click="isSidebarVisible = !isSidebarVisible"
			size="28"
			class="cursor-pointer"
		/>

		<div class="ml-auto flex items-center gap-2">
			<HeaderLanguage class="mr-4" />
			<!-- <button @click="copyToken" class="mr-4">
				<Icon name="mdi:content-copy" size="22" />
			</button> -->
			<Button @click="handleLogout" variation="secondary">
				<Icon name="mdi:account-circle" size="22" />
				{{ authStore?.user?.name }}</Button
			>
		</div>

		<UIConfirmDialog ref="dialogRef" />
	</header>
</template>

<script setup>
import useAuthStore from '~/store/auth'
import useSocketStore from '~/store/socket'

const authStore = useAuthStore()
const socketStore = useSocketStore()

const isOnline = useState('isOnline')

const dialogRef = ref(null)

const isSidebarVisible = useState('isSidebarVisible', () => true)

const handleLogout = async () => {
	try {
		await dialogRef.value.present({
			heading: 'Odhlásiť sa',
			body: 'Naozaj sa chcete odhlásiť?',
			ctaButton: 'Odhlásiť sa'
		})
		await authStore.logout()

		socketStore.disconnect()

		await navigateTo('/login')
	} catch (error) {}
}
</script>

<style scoped>
/* Tenký modrý pruh pod hlavičkou — odlíšenie Boxy od Deal Planet. */
[data-boxy-header]::after {
	content: '';
	@apply absolute left-0 right-0 -bottom-px h-[2px];
	background: linear-gradient(90deg, #8fdbff 0%, #2fb0ff 45%, #1a4fcf 100%);
}

[data-online] {
	@apply relative;
}
[data-online='true']::after {
	content: '';
	@apply absolute top-[3px] right-[3px] w-1.5 h-1.5 rounded-full bg-green-500;
}

[data-online='false']::after {
	content: '';
	@apply absolute top-[3px] right-[3px] w-1.5 h-1.5 rounded-full bg-red-500;
}
</style>
